/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExternalStockCalculationDto } from '../models/ExternalStockCalculationDto';
import type { ExternalStockVehicleDataDto } from '../models/ExternalStockVehicleDataDto';
import type { ExternalStockVehicleDataDtoPagedListData } from '../models/ExternalStockVehicleDataDtoPagedListData';
import type { FinanceTypeEnum } from '../models/FinanceTypeEnum';
import type { StockFilterResponseDTO } from '../models/StockFilterResponseDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExternalStockService {

  /**
   * @param regNumber 
   * @param mileageFrom 
   * @param mileageTo 
   * @param registrationDateFrom 
   * @param registrationDateTo 
   * @param manufacture 
   * @param model 
   * @param description 
   * @param transmission 
   * @param fuelType 
   * @param color 
   * @param orderByHighestPrice 
   * @param priceMin 
   * @param priceMax 
   * @param supplierAuction 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns ExternalStockVehicleDataDtoPagedListData Success
   * @throws ApiError
   */
  public static getExternalStockGetExternalStockVehicleData(
regNumber?: string,
mileageFrom?: number,
mileageTo?: number,
registrationDateFrom?: string,
registrationDateTo?: string,
manufacture?: string,
model?: Array<string>,
description?: Array<string>,
transmission?: number,
fuelType?: number,
color?: Array<string>,
orderByHighestPrice?: boolean,
priceMin?: number,
priceMax?: number,
supplierAuction?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<ExternalStockVehicleDataDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/external-stock/get-external-stock-vehicle-data',
      query: {
        'RegNumber': regNumber,
        'MileageFrom': mileageFrom,
        'MileageTo': mileageTo,
        'RegistrationDateFrom': registrationDateFrom,
        'RegistrationDateTo': registrationDateTo,
        'Manufacture': manufacture,
        'Model': model,
        'Description': description,
        'Transmission': transmission,
        'FuelType': fuelType,
        'Color': color,
        'OrderByHighestPrice': orderByHighestPrice,
        'PriceMin': priceMin,
        'PriceMax': priceMax,
        'SupplierAuction': supplierAuction,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns ExternalStockVehicleDataDto Success
   * @throws ApiError
   */
  public static getExternalStockGetExternalStockVehicleData1(
id: number,
): CancelablePromise<ExternalStockVehicleDataDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/external-stock/get-external-stock-vehicle-data/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param regNumber 
   * @param mileageFrom 
   * @param mileageTo 
   * @param registrationDateFrom 
   * @param registrationDateTo 
   * @param manufacture 
   * @param model 
   * @param description 
   * @param transmission 
   * @param fuelType 
   * @param color 
   * @param orderByHighestPrice 
   * @param priceMin 
   * @param priceMax 
   * @param supplierAuction 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns StockFilterResponseDTO Success
   * @throws ApiError
   */
  public static getExternalStockGetExternalStockVehicleFilterData(
regNumber?: string,
mileageFrom?: number,
mileageTo?: number,
registrationDateFrom?: string,
registrationDateTo?: string,
manufacture?: string,
model?: Array<string>,
description?: Array<string>,
transmission?: number,
fuelType?: number,
color?: Array<string>,
orderByHighestPrice?: boolean,
priceMin?: number,
priceMax?: number,
supplierAuction?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<StockFilterResponseDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/external-stock/get-external-stock-vehicle-filter-data',
      query: {
        'RegNumber': regNumber,
        'MileageFrom': mileageFrom,
        'MileageTo': mileageTo,
        'RegistrationDateFrom': registrationDateFrom,
        'RegistrationDateTo': registrationDateTo,
        'Manufacture': manufacture,
        'Model': model,
        'Description': description,
        'Transmission': transmission,
        'FuelType': fuelType,
        'Color': color,
        'OrderByHighestPrice': orderByHighestPrice,
        'PriceMin': priceMin,
        'PriceMax': priceMax,
        'SupplierAuction': supplierAuction,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postExternalStockInsertExternalStockVehicleData(
requestBody?: ExternalStockVehicleDataDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/external-stock/insert-external-stock-vehicle-data',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putExternalStockUpdateExternalStockVehicleData(
userId?: number,
requestBody?: ExternalStockVehicleDataDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/external-stock/update-external-stock-vehicle-data',
      query: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteExternalStockDeleteExternalStockVehicleData(
id?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/external-stock/delete-external-stock-vehicle-data',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getExternalStockGetParsedDataFromMfdlVehicles(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/external-stock/get-parsed-data-from-mfdl-vehicles',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param term 
   * @param deposit 
   * @param annualMileage 
   * @param financeType
 *
 * 1 = HP
 *
 * 2 = PCP
 *
 * 3 = CS0
 *
 * 5 = x4x4
 *
 * 6 = PCPZero
 *
 * 7 = FL
 *
 * 9 = BCH
   * @returns ExternalStockCalculationDto Success
   * @throws ApiError
   */
  public static getExternalStockGetCalculation(
id: number,
term: number,
deposit: number,
annualMileage: number,
financeType?: FinanceTypeEnum,
): CancelablePromise<ExternalStockCalculationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/external-stock/{id}/get-calculation',
      path: {
        'id': id,
      },
      query: {
        'term': term,
        'deposit': deposit,
        'annualMileage': annualMileage,
        'financeType': financeType,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

}
